"use client";

import { Avatar, Heading, Text } from "@pamperedchef/design-system";
import type { HeadingTag } from "@/app/utilities/types";

import * as styles from "./ImageList.module.scss";

interface ImageSetting {
	imageSrc: string;
	headline: string;
	headlineTag?: HeadingTag;
	description: string;
}

export interface ImageListProps {
	headline?: string;
	headlineTag?: HeadingTag;
	images: ImageSetting[];
}

/**
 * ImageList component displays a list of settings with an image, title, and description.
 */
export function ImageList({
	headline,
	headlineTag,
	images
}: ImageListProps): JSX.Element {
	return (
		<ul className={styles["image-list"]}>
			<Heading
				className={styles["image-list__headline"]}
				tag={headlineTag || "h2"}
				styledAs="h2"
			>
				{headline}
			</Heading>
			{images.map((image, index) => (
				<li key={index} className={styles["image-list__item"]}>
					<div className={styles["image-list__image"]}>
						<Avatar
							src={image?.imageSrc}
							alt={image?.headline}
							style={{ width: 139, height: 139 }}
						/>
					</div>
					<div className={styles["image-list__text"]}>
						<Heading
							className={styles["image-list__item__title"]}
							tag={image?.headlineTag || "h3"}
							styledAs="h5"
						>
							{image?.headline}
						</Heading>
						<Text styledAs="xsl">{image?.description}</Text>
					</div>
				</li>
			))}
		</ul>
	);
}

export default ImageList;
